import RegisterRealOwnerError from './RegisterRealOwnerError';
class InvalidResourcesOwnerBirthday extends RegisterRealOwnerError {
    constructor(birthday, options) {
        super(`Can not register owner of resources birthday: ${birthday}`, options);
    }
}
export default InvalidResourcesOwnerBirthday;
